import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { useUsage } from "../../contexts/UsageContext";

export function UsageLimitBanner() {
  const { usage } = useUsage();

  if (!usage) return null;

  const pct = usage.limit > 0 ? (usage.used / usage.limit) * 100 : 0;

  // Nothing to show below 80%
  if (pct < 80 && usage.remaining > 0) return null;

  const resetDate = new Date(usage.period_end).toLocaleDateString("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // 100% — hard limit reached
  if (usage.remaining <= 0) {
    return (
      <div className="bg-brand-error/10 border border-brand-error rounded-lg px-4 py-3 mx-4 mb-2 flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-brand-error shrink-0" />
        <div className="flex-1">
          <p className="text-sm text-brand-text">
            Vous avez atteint votre limite mensuelle. Votre quota se réinitialise le {resetDate}.
          </p>
          <Link
            to="/pricing"
            className="mt-1.5 inline-block text-sm font-medium text-brand-error hover:text-brand-text underline underline-offset-2 transition-colors"
          >
            Voir les forfaits →
          </Link>
        </div>
      </div>
    );
  }

  // 90-99% — orange warning
  if (pct >= 90) {
    return (
      <div className="bg-brand-warning/10 border border-brand-warning rounded-lg px-4 py-3 mx-4 mb-2 flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-brand-warning shrink-0" />
        <p className="text-sm text-brand-text">
          Il vous reste {usage.remaining} {usage.metering_mode === "chats" ? "conversation" : "message"}{usage.remaining > 1 ? "s" : ""}. Votre quota se réinitialise le {resetDate}.
        </p>
      </div>
    );
  }

  // 80-89% — yellow warning
  return (
    <div className="bg-[rgba(72,178,205,0.08)] border border-brand-teal rounded-lg px-4 py-3 mx-4 mb-2 flex items-center gap-3">
      <AlertTriangle className="w-5 h-5 text-brand-teal shrink-0" />
      <p className="text-sm text-brand-text">
        Il vous reste {usage.remaining} {usage.metering_mode === "chats" ? "conversation" : "message"}{usage.remaining > 1 ? "s" : ""} sur votre forfait.
      </p>
    </div>
  );
}
